import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'

import type { FC } from 'react'

interface EmptyListProps {
	componentSingularName?: string
	componentPluralName?: string
	onAdd?: () => void
}

export const EmptyList: FC<EmptyListProps> = ({
	componentPluralName = 'grids',
	componentSingularName = 'grid',
	onAdd,
}) => {
	const addProps = onAdd ? { onClick: onAdd } : { asChild: true }
	return (
		<div className="grid gap-4 auto-rows-min justify-items-center w-full">
			<h2 className="text-lg font-semibold">No {componentPluralName} yet</h2>
			<p className="text-sm text-muted-foreground">
				Create a new {componentSingularName} to get started.
			</p>
			{onAdd ? (
				<Button variant="outline" className="w-full cursor-pointer" {...addProps}>
					Add {componentSingularName}
				</Button>
			) : (
				<Button variant="outline" className="w-full cursor-pointer" asChild>
					<Link to="add">Add {componentSingularName}</Link>
				</Button>
			)}
		</div>
	)
}
